import type { ComponentProps } from 'preact';
import { useRoute } from 'preact-iso';

export function Link(props: ComponentProps<'a'> & { activeClassName?: string }) {
  const { path } = useRoute();
  if (props.activeClassName && path === props.href) {
    if (props.class) props.class += ` ${props.activeClassName}`;
    if (props.className) props.className += ` ${props.activeClassName}`;
  }
  return <a {...props} />;
}
